import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
import { openCalendlyPopup } from '../utils/calendly';
export function Header() {
  return <nav className="absolute top-0 left-0 w-full z-50 py-6 px-4 sm:px-6 lg:px-8" data-id="element-44" data-mp="2do7fdl1tkset">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-45" data-mp="2ink3e94fg5iz">
        <Link to="/" className="text-2xl font-bold text-white tracking-tight hover:opacity-90 transition-opacity" data-id="element-46" data-mp="2nm54sbvf0v90">
          Justus<span className="text-[#FF5722]" data-id="element-47" data-mp="2wkyx3q1pqzgr">Kraft</span>
        </Link>
        <Button variant="primary" size="sm" onClick={openCalendlyPopup} data-id="element-48" data-mp="2wj5pa7fd6976">
          Free Demo
        </Button>
      </div>
    </nav>;
}